import { CRM_API, RequestHelper } from "utils";

const RUTA = "transaccionesRecurrentes";
export const TransaccionesRecurrentesService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}`, params);
    });
  };

  const crear = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}`, data);
    });
  };

  const buscarPorId = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/${params}`, params);
    });
  };

  const actualizar = function (id, args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).put(`${RUTA}/${id}`, data);
    });
  };

  const cancelar = function (id) {
    return new Promise((res) => res(id)).then(() => {
      return RequestHelper(CRM_API).put(`${RUTA}/${id}/cancelar`, {});
    });
  };

  const historicoEnvios = function (id) {
    return new Promise((res) => res(id)).then(() => {
      return RequestHelper(CRM_API).get(`${RUTA}/${id}/envios`);
    });
  };

  const ejecutarProceso = function () {
    return RequestHelper(CRM_API).post(`${RUTA}/ejecutar-proceso`, {});
  };

  const exportarExcel = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/ExportarExcel`, params, true);
    });
  };

  return {
    listado,
    crear,
    buscarPorId,
    actualizar,
    cancelar,
    historicoEnvios,
    ejecutarProceso,
    exportarExcel
  };
})();
